import { defineStore } from 'pinia'

import { createCooperantOrdersActions } from './actions'
import { createCooperantOrdersState } from './state'

export const useCooperantOrdersStore = defineStore('cooperantOrders', () => {
    const state = createCooperantOrdersState()
    const actions = createCooperantOrdersActions(state)

    return {
        ...state,
        ...actions
    }
})
